<template>
  <div class="headlinepush-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加类型</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      title="添加类型"
      @on-ok="createpushtype('pushtypeValidate')"
      :loading="loading"
    >
      <Form
        :model="pushtype"
        ref="pushtypeValidate"
        :rules="pushtypeValidate"
        action="javascript:void(0)"
      >
        <FormItem label="类型名称" prop="name">
          <Input v-model="pushtype.name" placeholder="输入类型名称..."></Input>
        </FormItem>

        <FormItem label="图标">
          <upload-thumb
            v-model="pushtype.thumb"
            ref="uploadthumb"
            :defaultList="thumblist"
            :autoCropWidth="80"
            :autoCropHeight="80"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:80*80,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="pushtype.sort" placeholder="输入排序..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
  name: "headlinepush-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns: [
        {
          title: "排序",
          key: "sort",
          width: 100,
          fixed: "left"
        },
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "name",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      pushtype: {
        name: "",
        sort: 0
      },
      showModalStatus: false,
      pushtypeValidate: {
        name: [{ required: true, message: "类型名称必须填写", trigger: "blur" }]
      }
    };
  },
  // 计算
  computed: {},
  components: {
    UploadThumb
  },
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.headlinepush
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    // 展开添加
    showModel() {
      this.pushtypeid = 0;
      this.thumblist = new Array();
      this.pushtype = {
        name: "",
        sort: "0"
      };
      this.$refs["pushtypeValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function(index) {
      this.pushtypeid = index;
      this.$refs["pushtypeValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.thumblist = new Array();
      // 取信息
      this.$api.headlinepush.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.pushtype = res.result;
          console.log(this.pushtype.thumb);
          if (this.pushtype.thumb != null && this.pushtype.thumb != "") {
            this.thumblist.push({
              name: this.pushtype.thumb,
              url: this.pushtype.thumb,
              status: "finished"
            });
          }
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.pushtype.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.pushtype.thumb = null;
          }
          if (
            this.pushtypeid == null ||
            this.pushtypeid == 0 ||
            this.pushtypeid == undefined
          ) {
            this.$api.headlinepush
              .create({
                name: this.pushtype.name,
                thumb: this.pushtype.thumb,
                sort: this.pushtype.sort
              })
              .then(res => {
                if (res.code == 200) {
                  this.showModalStatus = !this.showModalStatus;
                  this.pushtype.name = "";
                  this.getTableList();
                }
              });
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
          } else {
            //编辑商品
            this.$api.headlinepush
              .edit({
                id: this.pushtypeid,
                name: this.pushtype.name,
                thumb: this.pushtype.thumb,
                sort: this.pushtype.sort
              })
              .then(res => {
                if (res.code == 200) {
                  this.getTableList();
                  this.showModalStatus = false;
                }
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
              });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.headlinepush.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>